import { Component, Input, OnInit } from "@angular/core";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";
import { EnvironmentConfig } from "../../../core/models/environment-config.model";
import { ModalService } from "../../../core/services/modal.service";

declare const environment: EnvironmentConfig;

@Component({
  selector: "common-image-gallery",
  templateUrl: "./image-gallery.component.html",
  styleUrls: ["./image-gallery.component.scss"],
})
export class ImageGalleryComponent implements OnInit {
  @Input() images: string[] = [];

  modalIndex = 0;
  imageSwipeConfig: SwiperConfigInterface = {
    navigation: true,
    loop: true,
    pagination: {
      type: "bullets",
      el: ".swiper-pagination",
      bulletActiveClass: "swiper-pagination-bullet-active active-bullet",
      bulletClass: "swiper-pagination-bullet inactive-bullet",
      clickable: true,
      modifierClass: "swiper-pagination-bullets bottom-0",
    },
  };
  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    this.images = this.images.map(path => environment.baseImagePath + path);
  }

  openModal(content: any, index: number = 0) {
    this.modalIndex = index;
    this.modalService.extraLargeModal(content, false).result.then(
      result => {},
      () => {},
    );
  }
}